import React from 'react';

export const TorchIcon = () => {
  return (
    <svg width="13" height="23" viewBox="0 0 13 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.8">
        <path
          d="M8.27121 0C2.98263 1.828 1.00415 5.35906 1.00415 7.82228C1.00415 9.70487 2.90939 12.3995 6.146 12.3995C8.86961 12.3995 11.3734 10.7359 11.3734 8.34579C11.3734 5.78403 7.45287 2.43736 8.27121 0Z"
          fill="#F6DA7E"
        />
        <path
          d="M7.42443 2.83325C4.27511 4.01874 3.09692 6.30874 3.09692 7.90621C3.09692 9.1271 4.23151 10.8746 6.1589 10.8746C7.78078 10.8746 9.27178 9.79572 9.27178 8.24569C9.27178 6.58435 6.93711 4.41395 7.42443 2.83325Z"
          fill="#FFEAA3"
        />
        <path
          d="M10.0319 13.7559H2.28169C1.6495 13.7559 1.13672 14.2726 1.13672 14.9035C1.13672 15.5344 1.6495 16.051 2.28169 16.051H10.0319C10.6641 16.051 11.1779 15.5344 11.1779 14.9035C11.1779 14.2726 10.6641 13.7559 10.0319 13.7559Z"
          fill="#FFEAA5"
        />
        <path
          d="M10.5178 10.4769H1.79992C0.805872 10.4769 0 11.289 0 12.2803C0 13.2717 0.805872 14.0836 1.79992 14.0836H10.5178C11.5106 14.0836 12.3177 13.2717 12.3177 12.2803C12.3177 11.289 11.5106 10.4769 10.5178 10.4769Z"
          fill="#6E577D"
        />
        <path
          d="M2.93066 16.0508C2.93066 16.0508 4.0076 20.9455 4.29171 22.2201C4.33148 22.407 4.49103 22.5429 4.6751 22.5429H7.67052C7.85495 22.5429 8.01447 22.407 8.05427 22.2201C8.33802 20.9455 9.41496 16.0508 9.41496 16.0508H2.93066Z"
          fill="#6E577D"
        />
        <path d="M3.54736 18.871L4.01647 21.0022H8.32899L8.79809 18.871H3.54736Z" fill="#FFEAA3" />
      </g>
    </svg>
  );
};
